import { availableHeaders } from '..'
import * as _ from 'lodash'

const checkHeaders = (headersToCheck: string[]) => {
  const headerHash: any = {}
  const invalidHeaders = _.filter(headersToCheck, (header) => {
    // const normalizedHeader = header.toLowerCase()
    if (headerHash[header]) {
      return true // invalid. duplicate column
    }
    headerHash[header] = 1
    return !availableHeaders.find((item) => item === header)
  })
  return { invalidHeaders, headersToCheck, uniqueColumnCount: Object.keys(headerHash).length }
}

export { checkHeaders }
